module.exports = __webpack_public_path__ + "img/instagram.d2736dde.svg";